export default function setAbasMenu() {
  const wrapper = document.querySelector('[data-abas-menu]');
  if (!wrapper) return;

  const toggle = wrapper.querySelector('[data-abas-menu-toggle]');
  const list = wrapper.querySelector('[data-abas-menu-list]');
  if (!toggle || !list) return;

  toggle.addEventListener('click', () => {
    wrapper.classList.toggle('-open');
  });
}
